import './duplicates-column-control.scss';
import {ColumnControlProps} from '../search-result-item-types';
import {BaseCol} from './base-col';
import React from 'react';
import {HibuTooltip} from '../../../../../common/hibuTooltip/hibuTooltip';
import {useTranslation} from 'react-i18next';

export const DuplicatesColumnControl = ({doc, isSelected}: ColumnControlProps): JSX.Element => {
    const {t} = useTranslation();
    if (!doc.duplicates || doc.duplicates.length === 0) {
        return <></>;
    } else {
        const amountDuplicates = doc.duplicates.length;
        const tooltipKey = amountDuplicates > 1 ? t('search.duplicates.tooltip_plural', {count: amountDuplicates}) : t('search.duplicates.tooltip_singular');
        return (
            <BaseCol className={'document-column-duplicates'}>
                {
                    <HibuTooltip tooltipKey={tooltipKey} placement={'top'}>
                        <div
                            className={`document-column-duplicates-count ${isSelected ? 'selected-doc-duplicates' : ''}`}>
                        <span>
                            {amountDuplicates}
                        </span>
                        </div>
                    </HibuTooltip>
                }
            </BaseCol>
        );
    }
};
